import Button from 'components/shared/Buttons/BaseButton';
import { BaseCard, BaseCardBox } from 'components/shared/Card/BaseCard';
import Media from 'components/shared/Media/Media';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import RichTextList from 'components/shared/RichTextList/RichTextList';
import { CrossSellProps } from 'libs/contentful/props';
import { cn } from 'utils/styles';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const CrossSell = ({ sys, color, title, copy, media, cta, layout = 'full' }: CrossSellProps) => {
  return (
    <BaseCard
      color={color}
      className={cn({
        'max-w-2xl-full sm:min-w-full': layout === 'sidebar',
        'my-12 sm:my-0': layout === 'full',
      })}>
      {media && <Media media={media} className="rounded-b-none" {...liveUpdateAttrs(sys?.id, 'image')}></Media>}
      <BaseCardBox
        className={cn({
          'lg:mx-6 lg:mt-8 lg:mb-6': layout === 'sidebar',
        })}>
        {title && (
          <div className="font-sans text-heading-sm mb-6">
            <RichTextHeadline headline={title} />
          </div>
        )}
        {copy && (
          <div className="font-serif text-body-serif">
            <RichTextList item={copy} />
          </div>
        )}
        {cta && (
          <div
            className={cn('mt-12 w-full ', {
              'md:w-96': layout === 'full',
            })}>
            <Button href={cta.url} variant="solid" sys={cta?.sys} internalPage={cta?.internalPage}>
              {cta.text}
            </Button>
          </div>
        )}
      </BaseCardBox>
    </BaseCard>
  );
};

export default CrossSell;
